import { FC } from 'react';
import { Box } from '@hopskipdrive/react-components';
import { BoxProps } from '@mui/material';
import styled from 'styled-components';

import { colorTokens } from '../variables';

interface IContactCard extends React.FC<BoxProps> {
  Title: FC<ContactCardTitleProps>;
  Content: FC<ContactCardContentProps>;
}

export const ContactCard: IContactCard = ({ children, color = colorTokens.info.main, ...props }) => {
  return (
    <ContactCardContainer color={color} {...props}>
      {children}
    </ContactCardContainer>
  );
};

interface ContactCardTitleProps {
  children?: React.ReactNode;
}

const ContactCardTitle: FC<ContactCardTitleProps> = ({ children }) => {
  return (
    <Box display="flex" flexDirection="row" alignItems="center" gap="12px" width="100%">
      {children}
    </Box>
  );
};

interface ContactCardContentProps {
  children: React.ReactNode;
}

const ContactCardContent: FC<ContactCardContentProps> = ({ children }) => {
  return (
    <Box display="flex" flexDirection="column" alignItems="start" gap="9px">
      {children}
    </Box>
  );
};

ContactCard.Title = ContactCardTitle;
ContactCard.Content = ContactCardContent;

const ContactCardContainer = styled(Box)`
  display: flex;
  padding: 12px 20px;
  width: 100%;
  align-items: center;
  align-content: center;
  gap: 12px;
  align-self: stretch;
  flex-wrap: wrap;
  border-radius: 0px 12px 12px 0px;
  border-left: 4.5px solid ${(props) => `${props.color}`};
  background: ${colorTokens.background.default};
`;
